import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'cpf'})
export class CpfPipe implements PipeTransform {
  transform(
    value: string | number | null | undefined,
    ocultarAlgunsValores: boolean = false,
  ): string {
    if (
      value === null ||
      value === undefined ||
      value === '' ||
      value === '-' ||
      value === 'null' ||
      value === 'undefined'
    ) {
      return '-';
    }

    const numeros = (value + '').replace(/\D/g, '');

    if (!numeros || numeros.length === 0 || /^0+$/.test(numeros)) {
      return '-';
    }

    const cpfLimpo = numeros.padStart(11, '0').slice(-11);
    let valorFormatado = cpfLimpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');

    if (ocultarAlgunsValores) {
      valorFormatado = 'XXX.' + valorFormatado.substr(4, 7) + '-XX';
    }

    return valorFormatado;
  }
  static format(
    value: string | number | null | undefined,
    ocultarAlgunsValores: boolean = false,
  ): string {
    const pipe = new CpfPipe();
    return pipe.transform(value, ocultarAlgunsValores);
  }
  /**
   * Valida se um CPF é válido
   * @param cpf O CPF a ser validado (com ou sem formatação)
   * @returns true se o CPF for válido, false caso contrário
   */
  static validarCPF(cpf: string): boolean {
    if (!cpf) return false;

    // Remove caracteres não numéricos
    const numeros = cpf.replace(/\D/g, '');

    // Verifica se tem 11 dígitos
    if (numeros.length !== 11) return false;

    // Verifica se todos os dígitos são iguais (CPF inválido)
    if (/^(\d)\1{10}$/.test(numeros)) return false;

    // Cálculo para validar CPF
    let soma = 0;
    let resto;

    for (let i = 1; i <= 9; i++) {
      soma = soma + parseInt(numeros.substring(i - 1, i)) * (11 - i);
    }

    resto = (soma * 10) % 11;

    if (resto === 10 || resto === 11) {
      resto = 0;
    }

    if (resto !== parseInt(numeros.substring(9, 10))) {
      return false;
    }

    soma = 0;

    for (let i = 1; i <= 10; i++) {
      soma = soma + parseInt(numeros.substring(i - 1, i)) * (12 - i);
    }

    resto = (soma * 10) % 11;

    if (resto === 10 || resto === 11) {
      resto = 0;
    }

    if (resto !== parseInt(numeros.substring(10, 11))) {
      return false;
    }

    return true;
  }

  /**
   * Formata um CPF (adiciona pontos e traço)
   * @param cpf O CPF a ser formatado
   * @returns O CPF formatado (XXX.XXX.XXX-XX)
   */
  static formatarCPF(cpf: string): string {
    if (!cpf || cpf === '-' || cpf === 'null' || cpf === 'undefined') return '';

    // Remove caracteres não numéricos
    const numeros = cpf.replace(/\D/g, '');
    if (!numeros || /^0+$/.test(numeros)) return '';

    // Aplica a formatação
    return numeros
      .padStart(11, '0')
      .slice(-11)
      .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  /**
   * Formata e valida um CPF
   * @param cpf O CPF a ser formatado e validado
   * @returns Um objeto contendo o CPF formatado e se é válido
   */
  static formatarEValidarCPF(cpf: string): {
    cpfFormatado: string;
    valido: boolean;
  } {
    const cpfFormatado = CpfPipe.formatarCPF(cpf);
    const valido = CpfPipe.validarCPF(cpfFormatado);

    return {
      cpfFormatado,
      valido,
    };
  }
}
